module.exports = __webpack_public_path__ + "img/MES9Indice5_cutout.5ec6f892.png";